import axios from "axios";
import { Loading } from "element-ui";
var options = {
  lock: true,
  text: "努力导出中...",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.7)",
};
// 导出
function exportData(url, formInline, exportName) {
  let loadingInstance = Loading.service(options);
  axios
    .post(
      url,
      { ...formInline },
      {
        timeout: 60000,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          "data-type": "Buffer",
        },
      }
    )
    .then((res) => {
      // 以服务的方式调用的 Loading 需要异步关闭
      loadingInstance.close();
      const link = document.createElement("a");
      let blob = new Blob([res.data], {
        type: "application/vnd.ms-excel",
      });
      // 给a标签添加属性
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      link.download = `${exportName}.xls`;
      document.body.appendChild(link);
      link.click(); //执行下载
      URL.revokeObjectURL(link.href); //释放url
      document.body.removeChild(link); //释放标签
    });
}

export default exportData;
